import { PapiEditorText } from '@wix/da-papi-types';

export enum OriginalDeviationFieldName {
  TITLE = 'title',
  DESCRIPTION = 'description',
  MATURE_CONTENT = 'matureContent',
  NO_AI = 'noAi',
  IS_AI_GENERATED = 'isAiGenerated',
  PRICE = 'price',
  TAGS = 'tags',
  DELIVERY_TIME = 'deliveryTime',
  DISPLAY_RESOLUTION = 'displayResolution',
  ADD_WATERMARK = 'addWatermark',
}

export interface OriginalDeviationFormFields {
  [OriginalDeviationFieldName.TITLE]: string;
  [OriginalDeviationFieldName.DESCRIPTION]: string;
  [OriginalDeviationFieldName.MATURE_CONTENT]: boolean;
  [OriginalDeviationFieldName.NO_AI]: boolean;
  [OriginalDeviationFieldName.IS_AI_GENERATED]: boolean;
  [OriginalDeviationFieldName.PRICE]: number;
  [OriginalDeviationFieldName.TAGS]: string[];
  [OriginalDeviationFieldName.DELIVERY_TIME]: number;
  [OriginalDeviationFieldName.DISPLAY_RESOLUTION]: string;
  [OriginalDeviationFieldName.ADD_WATERMARK]: boolean;
}

export enum QuestionFieldName {
  QUESTION = 'question',
  ANSWER_TYPE = 'answerType',
  ANSWER_CHOICES = 'answerChoices',
  IS_REQUIRED = 'isRequired',
}

export interface QuestionFormFields {
  [QuestionFieldName.QUESTION]: any;
  [QuestionFieldName.ANSWER_TYPE]: AnswerType;
  [QuestionFieldName.IS_REQUIRED]: boolean;
  [QuestionFieldName.ANSWER_CHOICES]?: AnswerChoice[];
}

export enum AnswerType {
  FREE_TEXT = 'free-text',
  SINGLE_CHOICE = 'single-choice',
  MULTIPLE_CHOICE = 'multiple-choice',
}

export interface AnswerChoice {
  answerText: string;
  price?: number;
}

export interface Question {
  id: string;
  questionBody: PapiEditorText;
  answerType: AnswerType;
  isRequired: boolean;
  answerChoices?: AnswerChoice[];
}

// this will be replaced by papi types once BE exists
export interface OriginalDeviation {
  title: string;
  description: PapiEditorText;
  matureContent?: boolean;
  noAi?: boolean;
  isAiGenerated?: boolean;
  price: number;
  tags: string[];
  deliveryTime: number;
  displayResolution: string;
  addWatermark: boolean;
  questions: Question[];
}
